import $api from "../../axios"
import {AppDispatch} from "../index"
import {orderSlice} from "../slices/orderSlice"
import {
  IFetchOrdersParams,
  IGetOrderParams,
  IOrder,
  IOrderFilters,
  IOrderListPayload,
  IOrderPaymentType
} from "../../models/order"

export const fetchOrders = (params: IFetchOrdersParams) => async (dispatch: AppDispatch) => {
  try {
    dispatch(orderSlice.actions.fetching())
    const response = await $api.get<IOrderListPayload>("request/request/index", { params })
    dispatch((orderSlice.actions.fetchSuccess(response.data)))
  } catch (e: any) {
    dispatch(orderSlice.actions.fetchError(e))
  }
}

export const createOrder = (data: object) => async (dispatch: AppDispatch) => {
  try {
    dispatch(orderSlice.actions.creating())
    await $api.post<IOrder>("request/request/add", data)
    dispatch(orderSlice.actions.createSuccess())
    return true
  } catch (e: any) {
    if (e.response.status === 422) {
      dispatch(orderSlice.actions.saveError(e.response.data))
    } else {
      dispatch(orderSlice.actions.creationError(e))
    }
  }
}

export const updateOrder = (data: object) => async (dispatch: AppDispatch) => {
  try {
    dispatch(orderSlice.actions.updating())
    await $api.put("request/request/edit", data)
    dispatch(orderSlice.actions.updateSuccess())
    return true
  } catch (e: any) {
    if (e.response.status === 422) {
      dispatch(orderSlice.actions.saveError(e.response.data))
    } else {
      dispatch(orderSlice.actions.updateError(e))
    }
  }
}

export const getOrderPaymentTypes = () => async (dispatch: AppDispatch) => {
  try {
    const response = await $api.get<IOrderPaymentType[]>("request/request/get-payment-types")
    dispatch(orderSlice.actions.fetchPaymentTypesSuccess(response.data))
  } catch (e:any) {
    console.log(e)
  }
}

export const getOrderStatuses = () => async (dispatch: AppDispatch) => {
  try {
    const response = await $api.get("request/request/get-request-statuses")
    dispatch(orderSlice.actions.fetchStatusesSuccess(response.data))
  } catch (e: any) {
    console.log(e)
  }
}

export const setOrderFilters = (filters: IOrderFilters) => (dispatch: AppDispatch) => {
  dispatch(orderSlice.actions.setFilters(filters))
}

export const getOrder = (params: IGetOrderParams) => async (dispatch: AppDispatch) => {
  try {
    dispatch(orderSlice.actions.fetchingOrder())
    const response = await $api.get<IOrder>("request/request/get", {params})
    dispatch(orderSlice.actions.fetchOrderSuccess(response.data))
  } catch (e: any) {
    dispatch(orderSlice.actions.fetchOrderError(e))
  }
}

export const cancelOrder = (order_id: number) => async (dispatch: AppDispatch) => {
  try {
    await $api.put("request/request/cancel", {request_id: order_id})
    return true
  } catch (e: any) {
    console.log(e)
  }
}

export const fetchDriverOrdersNew = (params: IFetchOrdersParams) => async (dispatch: AppDispatch) => {
  try {
    dispatch(orderSlice.actions.fetching())
    const response = await $api.get<IOrderListPayload>("driver/driver/new-request", { params })
    dispatch((orderSlice.actions.fetchSuccess(response.data)))
  } catch (e: any) {
    dispatch(orderSlice.actions.fetchError(e))
  }
}

export const fetchDriverOrdersCurrent = (params: IFetchOrdersParams) => async (dispatch: AppDispatch) => {
  try {
    dispatch(orderSlice.actions.fetching())
    const response = await $api.get<IOrderListPayload>("driver/driver/index", { params })
    dispatch((orderSlice.actions.fetchSuccess(response.data)))
  } catch (e: any) {
    dispatch(orderSlice.actions.fetchError(e))
  }
}

export const fetchDriverOrdersCompleted = (params: IFetchOrdersParams) => async (dispatch: AppDispatch) => {
  try {
    dispatch(orderSlice.actions.fetching())
    const response = await $api.get<IOrderListPayload>("driver/driver/complete-request", { params })
    dispatch((orderSlice.actions.fetchSuccess(response.data)))
  } catch (e: any) {
    dispatch(orderSlice.actions.fetchError(e))
  }
}

export const driverAcceptOrder = (request_id: number) => async (dispatch: AppDispatch) => {
  try {
    const response = await $api.post("driver/driver/accept-request", {request_id})
    return response.data.id
  } catch (e: any) {
    console.log(e)
  }
}

export const driverFinishOrder = (request_id: number) => async () => {
  try {
    const response = await $api.put("driver/driver/finish-request", {request_id})
    return response.data.id
  } catch (e: any) {
    console.log(e)
  }
}

export const setCurrentPage = (pageNumber: number) => (dispatch: AppDispatch) => {
  dispatch(orderSlice.actions.setCurrentPage(pageNumber))
}

export const setCreatingFromCallFlag = (flag: boolean) => (dispatch: AppDispatch) => {
  console.log(`set creating from call`)
  dispatch(orderSlice.actions.setCreatingFromCallFlag(flag))
}
